export type Disposition = 'Valid' | 'Invalid' | 'Needs Validation';
export type Avoidability = 'Avoidable' | 'Unavoidable';

export interface PostRevisionBadge {
	text: string;
	icon?: string;
	className?: string;
}

export const POST_REVISION_DISPOSITION_CONFIG: Record<
	Disposition,
	PostRevisionBadge
> = {
	'Needs Validation': {
		text: 'Needs Validation',
		icon: 'fa-light fa-circle-question',
		className: 'badge-needs-validation',
	},
	Valid: {
		text: 'Request Not Valid',
		icon: 'fa-light fa-circle-check',
		className: 'badge-valid',
	},
	Invalid: {
		text: 'Correction Required',
		icon: 'fa-light fa-circle-exclamation',
		className: 'badge-invalid',
	},
};

export const POST_REVISION_AVOIDABILITY_CONFIG: Record<Avoidability, PostRevisionBadge> = {
	Avoidable: {
		text: 'Avoidable',
		className: 'badge--avoidable',
	},
	Unavoidable: {
		text: 'Unavoidable',
		className: 'badge--unavoidable',
	},
};